// @ts-nocheck
import { StoreListCollectionModel } from "@store/Framework/Types/ApiModels";
import { getStoreLists, GetStoreListsApiParameter } from "@store/Services/StoreListService";
import { ApiHandler, createHandlerChainRunner } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = ApiHandler<GetStoreListsApiParameter, StoreListCollectionModel>;

export const DispatchBeginLoadStoreLists: HandlerType = props => {
    props.dispatch({
        type: "Data/StoreLists/BeginLoadStoreLists",
        parameter: props.parameter,
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getStoreLists(props.apiParameter);
};

export const DispatchCompleteLoadStoreLists: HandlerType = props => {
    props.dispatch({
        type: "Data/StoreLists/CompleteLoadStoreLists",
        result: props.apiResult,
        parameter: props.parameter,
    });
};

export const chain = [
    DispatchBeginLoadStoreLists,
    PopulateApiParameter,
    RequestDataFromApi,
    DispatchCompleteLoadStoreLists,
];

const loadStoreLists = createHandlerChainRunner(chain, "LoadStoreLists");
export default loadStoreLists;
